module.exports = __webpack_public_path__ + "static/media/artes.e1c198cd.svg";